import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "amfe-flexible";
import "./styles/brand.css";
import "./styles/tabbar.css";
import axios from "axios";
Vue.config.productionTip = false;
Vue.prototype.$http = axios;
import { Lazyload } from "vant";
// main.js
import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  keyName: "metaInfo", // 自定义元信息字段名
  refreshOnceOnNavigation: true, // 路由切换时刷新一次
});
// 注册时可以配置额外的选项
Vue.use(Lazyload, {
  lazyComponent: true,
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
